import { IPopMessageIcon } from './types'
import styles from './styles.module.scss'

const PopMessageIcon = ({ variant }: IPopMessageIcon) => {
  switch (variant) {
    case 'warning':
      return (
        <svg
          className={styles[variant]}
          height="16"
          viewBox="0 0 512 512"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" />
        </svg>
      )
    case 'error':
      return (
        <svg
          className={styles[variant]}
          height="16"
          viewBox="0 0 512 512"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
        </svg>
      )
    case 'success':
      return (
        <svg
          className={styles[variant]}
          height="16"
          viewBox="0 0 512 512"
          width="16"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
        </svg>
      )
    default:
      return (
        <svg
          className={styles['default']}
          height="16"
          viewBox="0 0 448 512"
          width="14"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M208 0H332.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H208c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128h80v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z" />
        </svg>
      )
  }
}

export default PopMessageIcon
